import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { TicketType } from '../../models/entities/ticket-type-entity';
import { TicketStatus } from '../../models/entities/ticket-status-entity';
import { TicketService } from '../../services/ticket-service';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
    selector: 'ticket-status-lov',
    templateUrl: './ticket-status-lov.component.html',
    styleUrls: ['./ticket-status-lov.component.scss']
})

export class TicketStatusLovComponent extends GenericLovComponent  {

  ticketType : TicketType;
  

    ticketStatuses   : TicketStatus[] = [];
    columns = [
      {  prop: 'ticketStatusCode',    name: 'Code'},
      {  prop: 'name',                name: 'Name' }
  ]

    constructor(
      public dialogRef: MatDialogRef<TicketStatusLovComponent>,
          protected ticketService : TicketService,
          protected toastr: ToastrService,
          protected router: Router,
          protected location : Location) {
            super();
    }

   

    loadData() {
      this.ticketService.ticketStatusGet().then(ticketStatuses => {
        this.ticketStatuses   = ticketStatuses;
    });
  }

//----------------------------------------------------------------------
closeModal(row : TicketStatus){
  this.dialogRef.close(row);
}
//----------------------------------------------------------------------


}
